export function formatChemicalUnit(unit: string | undefined | null): string {
  if (!unit) {
    return '';
  }
  return unit.replace(/CO2e/gi, 'CO₂e').replace(/NOx/gi, 'NOₓ');
}
